import { Button, Icon, useTheme } from '@hover/blueprint';
import { iChevronLeft, iChevronRight } from '@hover/icons';
import React from 'react';

import { useFocusedView } from 'src/modules/renderings/hooks/useFocusedView';

interface ImageNavigationButtonProps {
  direction: 'right' | 'left';
  onClick: () => void;
}

const ImageNavigationButton = ({
  onClick,
  direction,
}: ImageNavigationButtonProps) => {
  const isRight = direction === 'right';
  const icon = isRight ? iChevronRight : iChevronLeft;

  const { isFocusedView } = useFocusedView();
  const theme = useTheme();
  const colors = theme.colors ?? {};

  const backgroundColor = isFocusedView ? colors.neutral900 : colors.neutral0;
  const iconColor = isFocusedView ? colors.neutral0 : colors.neutral900;

  return (
    <Button
      backgroundColor={backgroundColor}
      fill="minimal"
      height="500"
      justifyContent={isRight ? 'end' : 'start'}
      label={`move-to-image-${direction}`}
      left={isRight ? 'unset' : '0px'}
      margin="0"
      marginLeft={{ base: 'unset', desktop: isRight ? 'unset' : '-16px' }}
      marginRight={{ base: 'unset', desktop: isRight ? '-16px' : 'unset' }}
      marginTop="-16px"
      onClick={onClick}
      position="absolute"
      right={isRight ? '0px' : 'unset'}
      shape="square"
      sx={{
        width: 300,
      }}
      top="50%"
    >
      <Icon color={iconColor} icon={icon} sx={{ width: undefined }} />
    </Button>
  );
};

export { ImageNavigationButton };
